import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'form-radio',
  templateUrl: './form-radio.component.html',
  styleUrls: ['./form-radio.component.css']
})
export class FormRadioComponent implements OnInit {
  config;
  group: FormGroup;

  getChoices(fieldName) {
    return this.group.get(fieldName);
  }

  constructor() { }

  ngOnInit() {
  }

}
